/**
 * Draft vs published calendar tab entries (Firestore `calendarTabEntries`).
 * - draftText: auto-saved while editing; visible only to editors until published
 * - publishedText: live copy for shares and calendar schedule display
 * - text: legacy field; kept in sync on publish for older clients
 */

export function getTabEntryDraftText(row = {}) {
  if (row.draftText != null && String(row.draftText).length > 0) {
    return String(row.draftText);
  }
  return String(row.text || '');
}

export function getTabEntryPublishedText(row = {}) {
  if (row.publishedText != null && String(row.publishedText).length > 0) {
    return String(row.publishedText);
  }
  return String(row.text || '');
}

export function hasUnpublishedTabDraft(draftText, publishedText) {
  return String(draftText || '').trim() !== String(publishedText || '').trim();
}

export function buildTabEntryDraftFields({
  tourId,
  tabKey,
  date,
  draftText,
  textColor,
  textAlign,
  fontSize,
}) {
  return {
    tourId,
    tabKey,
    date,
    draftText: String(draftText ?? ''),
    textColor: textColor || '#111111',
    textAlign: textAlign || 'left',
    fontSize: Number(fontSize) || 13,
    draftUpdatedAt: new Date().toISOString(),
  };
}

export function buildTabEntryPublishFields({
  tourId,
  tabKey,
  date,
  draftText,
  textColor,
  textAlign,
  fontSize,
}) {
  const published = String(draftText ?? '');
  return {
    tourId,
    tabKey,
    date,
    draftText: published,
    publishedText: published,
    text: published,
    textColor: textColor || '#111111',
    textAlign: textAlign || 'left',
    fontSize: Number(fontSize) || 13,
    publishedAt: new Date().toISOString(),
  };
}
